import { AxiosPromise } from 'axios';
import { ILoginPageFormValues } from './types';
import { instance } from '../../services/api';

const attemptLogin = (data: ILoginPageFormValues): AxiosPromise =>
  instance.post('api/accounts', data);

export default attemptLogin;
